import { Check } from "@untitled-ui/icons-react";
import { type ReactNode } from "react";

import DoubleCheck from "@/components/icons/DoubleCheck";
import Badge from "@/components/text/Badge";
import { cn } from "@/lib/utils";

export default function MessengerCard({
  image,
  title,
  subtitle,
  isRead,
  unreadCount,
  isActive,
  onClick,
}: {
  image: ReactNode;
  title: ReactNode;
  subtitle?: ReactNode;
  isRead?: boolean;
  unreadCount?: number;
  isActive?: boolean;
  onClick: () => void;
}) {
  return (
    <div
      className={cn(
        "flex cursor-pointer items-center rounded-lg px-4 py-2",
        isActive ? "bg-primary-600 text-white" : "hover:bg-gray-50",
      )}
      onClick={onClick}
    >
      {image}
      <div className="ms-3 flex min-w-0 flex-1 flex-col gap-1">
        <div className="flex items-center justify-between gap-2">
          <span
            className={cn(
              "truncate font-medium",
              isActive ? "text-white" : "text-gray-700",
            )}
          >
            {title}
          </span>
          {isRead !== undefined &&
            (isRead ? (
              <DoubleCheck
                className={cn(
                  "size-4 shrink-0",
                  isActive ? "text-white" : "text-primary-600",
                )}
              />
            ) : (
              <Check
                className={cn(
                  "size-4 shrink-0",
                  isActive ? "text-white" : "text-primary-600",
                )}
              />
            ))}
        </div>
        {(subtitle || (unreadCount ?? 0) > 0) && (
          <div className="flex items-center justify-between gap-2">
            <span
              className={cn(
                "truncate text-sm",
                isActive ? "text-white" : "text-gray-400",
              )}
            >
              {subtitle}
            </span>
            {(unreadCount ?? 0) > 0 && <Badge size="sm">{unreadCount}</Badge>}
          </div>
        )}
      </div>
    </div>
  );
}
